import React, { MutableRefObject, useState } from 'react'
import { BodyDados, FormDados } from '../../styled'
import ImgCrop from 'antd-img-crop'
import { Modal, Radio, Upload, UploadFile } from 'antd'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadRequestOption } from 'rc-upload/lib/interface'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import Input from '../../../CustomUi/input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAddressCard,
  faArrowUpFromBracket,
  faBriefcase,
  faBuilding,
  faCity,
  faClipboardList,
  faEnvelope,
  faFileSignature,
  faFolderOpen,
  faGlobe,
  faHashtag,
  faHouseChimneyWindow,
  faIdBadge,
  faLocationDot,
  faMap,
  faMobileScreenButton,
  faPersonHalfDress,
  faPhone,
  faPlus,
  faRoad,
  faStamp,
} from '@fortawesome/free-solid-svg-icons'

import { Box } from '../../../CustomUi/box'
import DatePicker from '../../../DatePiker'
import dayjs, { Dayjs } from 'dayjs'
import { Select } from '../../../CustomUi/Select'
import { Render } from '../../../CustomUi/render'
import { apenasNumeros, maskCNPJ } from '../../../../utils'
import { cepMask, cpfMask, fixoMask, maskRg, phoneMask } from '../../../../services/Afins'

interface PropsFormDados {
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  tipo_cliente: string
  setTipo_cliente: React.Dispatch<React.SetStateAction<string>>
  dataNascimento?: Dayjs | null
  setDataNascimento?: React.Dispatch<React.SetStateAction<Dayjs | null>>
  cpf: string
  setCpf: React.Dispatch<React.SetStateAction<string>>
  rg: string
  setRg: React.Dispatch<React.SetStateAction<string>>
  orgao_expedidor: string
  setOrgao_expedidor: React.Dispatch<React.SetStateAction<string>>
  sexo: string
  setSexo: React.Dispatch<React.SetStateAction<string>>
  nacionalidade: string
  setNacionalidade: React.Dispatch<React.SetStateAction<string>>
  escolaridade: string
  setEscolaridade: React.Dispatch<React.SetStateAction<string>>
  escolaridadeId: number
  setEscolaridadeId: React.Dispatch<React.SetStateAction<number>>
  estado_civil: string
  setEstado_civil: React.Dispatch<React.SetStateAction<string>>
  estado_civilId: number
  setEstado_civilId: React.Dispatch<React.SetStateAction<number>>
  profissao: string
  setProfissao: React.Dispatch<React.SetStateAction<string>>
  profissaoId: number
  setProfissaoId: React.Dispatch<React.SetStateAction<number>>
  celular: string
  setCelular: React.Dispatch<React.SetStateAction<string>>
  fone_fixo: string
  setFone_fixo: React.Dispatch<React.SetStateAction<string>>
  email: string
  setEmail: React.Dispatch<React.SetStateAction<string>>
  estado: string
  setEstado: React.Dispatch<React.SetStateAction<string>>
  estadoId: number
  setEstadoId: React.Dispatch<React.SetStateAction<number>>
  cidade: string
  setCidade: React.Dispatch<React.SetStateAction<string>>
  cidadeId: number
  setCidadeId: React.Dispatch<React.SetStateAction<number>>
  cep: string
  setCep: React.Dispatch<React.SetStateAction<string>>
  logradouro: string
  setLogradouro: React.Dispatch<React.SetStateAction<string>>
  numero: string
  setNumero: React.Dispatch<React.SetStateAction<string>>
  bairro: string
  setBairro: React.Dispatch<React.SetStateAction<string>>
  complemento: string
  setComplemento: React.Dispatch<React.SetStateAction<string>>
  outros: string
  setOutros: React.Dispatch<React.SetStateAction<string>>
  razao_social: string
  setRazao_social: React.Dispatch<React.SetStateAction<string>>
  cnpj: string
  setCnpj: React.Dispatch<React.SetStateAction<string>>
  ie: string
  setIe: React.Dispatch<React.SetStateAction<string>>
  uploadLogo: MutableRefObject<any>
  handleChangeUpload: (info: UploadChangeParam<UploadFile<any>>) => void
  dummyRequest: (options: UploadRequestOption<any>) => void
  onPreview: (file: UploadFile<any>) => void
  fileListImg: any
  onRemoveLogo: (file: UploadFile<any>) => boolean | void | Promise<boolean | void>
  previewVisibleImg: boolean
  setPreviewVisibleImg: React.Dispatch<React.SetStateAction<boolean>>
  handleChangeCidadeUf: Function
  imageUrl: string
  dataEstados: any[]
  dataCidade: any[]
  dataCE: any[]
  dataEC: any[]
  dataPR: any[]
}

export const FormDadosClientes: React.FC<PropsFormDados> = ({
  tipo_cliente,
  setTipo_cliente,
  nome,
  setNome,
  dataNascimento,
  setDataNascimento,
  cpf,
  setCpf,
  rg,
  setRg,
  orgao_expedidor,
  setOrgao_expedidor,
  sexo,
  setSexo,
  nacionalidade,
  setNacionalidade,
  escolaridade,
  escolaridadeId,
  setEscolaridade,
  setEscolaridadeId,
  estado_civil,
  setEstado_civil,
  estado_civilId,
  setEstado_civilId,
  profissao,
  setProfissao,
  profissaoId,
  setProfissaoId,
  celular,
  setCelular,
  fone_fixo,
  setFone_fixo,
  email,
  setEmail,
  estado,
  setEstado,
  estadoId,
  setEstadoId,
  cidade,
  setCidade,
  cidadeId,
  setCidadeId,
  cep,
  setCep,
  logradouro,
  setLogradouro,
  numero,
  setNumero,
  bairro,
  setBairro,
  complemento,
  setComplemento,
  outros,
  setOutros,
  razao_social,
  setRazao_social,
  cnpj,
  setCnpj,
  ie,
  setIe,
  uploadLogo,
  handleChangeUpload,
  dummyRequest,
  onPreview,
  fileListImg,
  onRemoveLogo,
  previewVisibleImg,
  setPreviewVisibleImg,
  imageUrl,
  dataEstados,
  dataCidade,
  dataCE,
  dataEC,
  dataPR,
  handleChangeCidadeUf
}) => {
  const [openEscolaridade, setOpenEscolaridade] = useState<boolean>(false)
  const [openProfissao, setOpenProfissao] = useState<boolean>(false)
  const [openEstadoCivil, setOpenEstadoCivil] = useState<boolean>(false)
  const [openEstado, setOpenEstado] = useState<boolean>(false)
  const [openCidade, setOpenCidade] = useState<boolean>(false)

  const handleDateChange = (date: Dayjs) => {
    setDataNascimento(date)
  }

  const handleDateBlur = (e) => {
    const dateString = e.target.value

    // Valida a data digitada e define no estado caso seja válida
    if (dayjs(dateString, 'DD/MM/YYYY', true).isValid()) {
      setDataNascimento(dayjs(dateString, 'DD/MM/YYYY'))
    }
  }

  return (
    <BodyDados>
      <Box style={{ gap: '5px' }}>
        <label>Tipo do cliente</label>
        <Radio.Group
          buttonStyle='outline'
          onChange={(e) => setTipo_cliente(e.target.value)}
          value={tipo_cliente}
        >
          <Radio name='tipo' value='F'>
            Pessoa física
          </Radio>

          <Radio name='tipo' value='J'>
            Pessoa jurídica
          </Radio>

          <Radio name='tipo' value='G'>
            Grupo
          </Radio>
        </Radio.Group>
      </Box>
      <FormDados>
        <div className='foto-profile'>
          <ImgCrop modalOk='Salvar' modalTitle='Editar Logo' aspect={500 / 500} rotationSlider>
            <Upload
              ref={uploadLogo}
              className='foto-upload'
              accept='image/png, image/jpeg'
              onChange={handleChangeUpload}
              listType='picture-card'
              customRequest={dummyRequest}
              onPreview={onPreview}
              fileList={fileListImg}
              onRemove={onRemoveLogo}
              maxCount={1}
            >
              {fileListImg?.length < 1 && (
                <div>
                  <FontAwesomeIcon icon={faArrowUpFromBracket} className='icone-upload' />
                </div>
              )}
            </Upload>
          </ImgCrop>
          <Modal
            open={previewVisibleImg}
            closeIcon={false}
            title='Logo'
            footer={null}
            onCancel={() => setPreviewVisibleImg(false)}
          >
            <img alt='example' style={{ width: '100%' }} src={imageUrl} />
          </Modal>
        </div>
        <div style={{ width: '77%', display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <Render condition={tipo_cliente === 'J'}>
            <Input
              label='CNPJ'
              icon={faBriefcase}
              placeholder='Digite o CNPJ'
              value={maskCNPJ(cnpj)}
              onChange={setCnpj}
              maxLength={18}
            />
          </Render>

          <div className='campo__dois__inputs'>
            <Input
              label={tipo_cliente !== 'J' ? 'Nome' : 'Nome fantasia'}
              placeholder='Digite o nome'
              icon={faFileSignature}
              value={nome}
              onChange={setNome}
              obrigatorio
            />
            <div className='data-nascimento'>
              <div style={{ display: 'flex', gap: '10', alignItems: 'center' }}>
                <label>{tipo_cliente === 'F' ? 'Data nascimento' : 'Fundado em'}</label>
              </div>
              <DatePicker
                value={dataNascimento ? dayjs(dataNascimento) : null}
                onChange={handleDateChange}
                style={{ height: '40px', borderRadius: '10px' }}
                onBlur={handleDateBlur}
              />
            </div>
          </div>
          <Render condition={tipo_cliente === 'J'}>
            <div className='campo__dois__inputs'>
              <Input
                label='Razão social'
                placeholder='Digite o CNPJ'
                value={razao_social}
                icon={faAddressCard}
                onChange={setRazao_social}
                obrigatorio
              />
              <Input
                label='IE'
                placeholder='Digite a inscrição estadual'
                value={apenasNumeros(ie)}
                icon={faClipboardList}
                onChange={setIe}
              />
            </div>
          </Render>
          <Render condition={tipo_cliente === 'F'}>
            <Input
              label='CPF'
              placeholder='Digite o CPF'
              value={cpfMask(cpf)}
              onChange={setCpf}
              icon={faIdBadge}
              maxLength={15}
            />
            <div className='campo__dois__inputs'>
              <Input
                label='RG'
                placeholder='Digite o RG'
                value={maskRg(rg)}
                onChange={setRg}
                icon={faAddressCard}
                maxLength={12}
              />
              <Input
                label='Órgão expedidor'
                placeholder='Digite o órgão expedidor'
                value={orgao_expedidor}
                onChange={setOrgao_expedidor}
                icon={faStamp}
              />
            </div>
          </Render>
          <Input
            label='Email'
            placeholder='Digite a email'
            value={email}
            onChange={setEmail}
            icon={faEnvelope}
            obrigatorio
          />
          <Render condition={tipo_cliente === 'F'}>
            <div className='campo__dois__inputs'>
              <div className='radio-sexo'>
                <div style={{ display: 'flex', gap: '10', alignItems: 'center' }}>
                  <label>Sexo</label>
                  <p
                    style={{
                      margin: '0',
                      padding: '0',
                      fontSize: '10px',
                      marginLeft: '3px',
                      opacity: '0.7',
                    }}
                  >
                    (Obrigatório)
                  </p>
                </div>
                <Radio.Group
                  value={sexo}
                  onChange={(e) => setSexo(e.target.value)}
                  className='radio-group'
                  style={{
                    height: '100%',
                    textAlign: 'center',
                    alignItems: 'center',
                  }}
                  optionType='button'
                  buttonStyle='solid'
                  options={[
                    {
                      label: 'Masculino',
                      value: 'M',
                      style: { width: '50%', height: '80%', textAlign: 'center' },
                    },
                    {
                      label: 'Feminino',
                      value: 'F',
                      style: { width: '50%', height: '80%', textAlign: 'center' },
                    },
                  ]}
                />
              </div>

              <Input
                label='Nacionalidade'
                placeholder='Digite a nacionalidade'
                value={nacionalidade}
                onChange={setNacionalidade}
                icon={faGlobe}
              />
            </div>

            <div className='campo__dois__inputs'>
              <Select
                label='Escolaridade'
                placeholder='Selecione a escolaridade'
                value={escolaridade}
                onChange={setEscolaridade}
                onChangeID={setEscolaridadeId}
                open={openEscolaridade}
                icon={faBuilding}
                trigger={setOpenEscolaridade}
                items={dataCE}
                descricaoItem={'nome'}
                idItem={'cod'}
              />
              <Select
                label='Profissão'
                placeholder='Selecione a profissão'
                icon={faBriefcase}
                value={profissao}
                onChange={setProfissao}
                onChangeID={setProfissaoId}
                open={openProfissao}
                trigger={setOpenProfissao}
                items={dataPR}
                descricaoItem={'nome'}
                idItem={'cod'}
              />
            </div>
            <Select
              label='Estado civil'
              placeholder='Selecione o estado civil'
              value={estado_civil}
              icon={faPersonHalfDress}
              onChange={setEstado_civil}
              onChangeID={setEstado_civilId}
              open={openEstadoCivil}
              trigger={setOpenEstadoCivil}
              items={dataEC}
              descricaoItem={'nome'}
              idItem={'cod'}
            />
          </Render>
          <div className='campo__dois__inputs'>
            <Input
              label='Celular'
              placeholder='(00) 00000-0000'
              value={phoneMask(celular)}
              onChange={setCelular}
              icon={faMobileScreenButton}
              maxLength={15}
            />
            <Input
              label='Telefone fixo'
              placeholder='(00) 0000-0000'
              value={fixoMask(fone_fixo)}
              onChange={setFone_fixo}
              icon={faPhone}
              maxLength={14}
            />
          </div>
          <Input
            label='CEP'
            placeholder='Digite o CEP'
            value={cepMask(cep)}
            onChange={setCep}
            icon={faLocationDot}
          />
          <div className='campo__dois__inputs'>
            <Select
              label='Estado'
              placeholder='Selecione o estado'
              value={estado}
              onChange={setEstado}
              onChangeID={(e) => handleChangeCidadeUf(e)}
              open={openEstado}
              trigger={setOpenEstado}
              items={dataEstados}
              descricaoItem={'nome'}
              icon={faMap}
              idItem={'cod'}
            />
            <Select
              label='Cidade'
              placeholder='Selecione o cidade'
              value={cidade}
              onChange={setCidade}
              onChangeID={setCidadeId}
              open={openCidade}
              trigger={setOpenCidade}
              items={dataCidade}
              icon={faCity}
              descricaoItem={'nome'}
              idItem={'cod'}
            />
          </div>
          <div className='campo__dois__inputs'>
            <Input
              label='Bairro'
              placeholder='Digite o bairro'
              value={bairro}
              onChange={setBairro}
              icon={faHouseChimneyWindow}
            />
            <Input
              label='Logradouro'
              placeholder='Digite o logradouro'
              value={logradouro}
              onChange={setLogradouro}
              icon={faRoad}
            />
          </div>
          <div className='campo__dois__inputs'>
            <Input
              label='Número'
              placeholder='Digite o número'
              value={numero}
              onChange={setNumero}
              icon={faHashtag}
            />
            <Input
              label='Complemento'
              placeholder='Digite o complemento'
              value={complemento}
              onChange={setComplemento}
              icon={faPlus}
            />
          </div>
          <Render condition={tipo_cliente !== 'G'}>
            <Input
              label='Outros solicitantes'
              placeholder='Digite o complemento'
              value={outros}
              onChange={setOutros}
              icon={faFolderOpen}
            />
          </Render>
        </div>
      </FormDados>
    </BodyDados>
  )
}
